export default "__VITE_ASSET__CinfHi0L__"